import { render, staticRenderFns } from "./ComparteGana.vue?vue&type=template&id=c9350896"
import script from "./ComparteGana.vue?vue&type=script&lang=js"
export * from "./ComparteGana.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports